import {Injectable} from '@angular/core';

import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';

import {Store} from '@stores/abstract-store';
import {
  LessonGenerationJob,
  LessonSource,
} from '@models/lesson-generation-types';

/**
 * Lessons being built from uploaded PDFs, in the order they were started; shown as snackbars.
 * LessonGenerationReactor builds each queued job and records its progress here.
 */
@Injectable({providedIn: 'root'})
export class LessonGenerationStore extends Store<LessonGenerationJob[]> {
  constructor() {
    super([]);
  }

  /** Adds an uploaded PDF to be built; returns the job's id. */
  queue(source: LessonSource): string {
    const id = U.generateId();
    this.setState([
      ...this.state(),
      {id, source, status: 'queued', progress: 0, hidden: false},
    ]);
    return id;
  }

  update(id: string, changes: Partial<Omit<LessonGenerationJob, 'id'>>) {
    if (!this.state().some((j) => j.id === id)) {
      return;
    }
    this.setState(
      this.state().map((j) => (j.id === id ? {...j, ...changes} : j)),
    );
  }

  /** Moves the progress bar forward (never back). */
  progress(id: string, percent: number) {
    const job = this.state().find((j) => j.id === id);
    if (job && percent > job.progress) {
      this.update(id, {progress: percent});
    }
  }

  /** Hides a processing snackbar; it shows again when the job finishes. */
  hide(id: string) {
    this.update(id, {hidden: true});
  }

  /** Removes a job; a job still building is stopped. */
  remove(id: string) {
    this.setState(this.state().filter((j) => j.id !== id));
  }
}
